<!-- Simple Reports Component -->
<div class="simple-reports-container">
  <!-- Custom Message Component -->
  <app-custom-message [messages]="customMessageService.getMessages()"></app-custom-message>
  <!-- Header -->
  <div class="header-section">
    <div class="header-content">
      <h1 class="page-title">
        <i class="pi pi-chart-bar"></i>
        Reports Dashboard
      </h1>
      <p class="page-description">
        Access predefined static reports for analytics and team performance, or create custom dynamic reports with flexible filtering.
      </p>
    </div>
    <div class="header-actions" *ngIf="activeTab === 'dynamic'">
      <p-button appGlobalLoadingDisable label="Create New Report" icon="pi pi-plus" (onClick)="createNewReport()" [loading]="loading" styleClass="p-button-primary">
      </p-button>
    </div>
  </div>

  <!-- Tabs -->
  <div class="tabs-section">
    <div class="tab-buttons">
      <button class="tab-btn" [class.active]="activeTab === 'static'" (click)="switchToTab('static')">
        <i class="pi pi-chart-pie"></i>
        Static Reports
      </button>
      <button class="tab-btn" [class.active]="activeTab === 'dynamic'" (click)="switchToTab('dynamic')">
        <i class="pi pi-cog"></i>
        Dynamic Reports
      </button>
    </div>
  </div>

  <!-- Static Reports Section -->
  <div class="static-reports-wrapper" *ngIf="activeTab === 'static'">
    <app-static-reports></app-static-reports>
  </div>

  <!-- Saved Reports and Templates Section -->
  <div class="templates-section" *ngIf="activeTab === 'dynamic' && !reportBuilderVisible && !reportExecutionVisible">
    <!-- Saved Reports -->
    <div class="saved-reports-section" *ngIf="savedReports.length > 0">
      <h2 class="section-title">
        <i class="pi pi-bookmark"></i>
        Your Saved Reports
      </h2>

      <div class="saved-reports-grid">
        <div class="saved-report-card" *ngFor="let report of savedReports" (click)="loadReport(report)">
          <div class="report-header">
            <div class="report-icon">
              <i [class]="getDataSourceIcon(report.dataSource)"></i>
            </div>
            <div class="report-badges">
              <span class="public-badge" *ngIf="report.isPublic">Public</span>
              <span class="data-source-badge">{{ report.dataSource }}</span>
            </div>
          </div>

          <div class="report-content">
            <h3 class="report-title">{{ report.name }}</h3>
            <p class="report-description" *ngIf="report.description">{{ report.description }}</p>
            <div class="report-meta">
              <span class="created-by" *ngIf="report.createdBy">
                by {{ report.createdBy.firstName }} {{ report.createdBy.lastName }}
              </span>
              <span class="created-date">{{ report.createdAt | date:'short' }}</span>
            </div>
          </div>

          <div class="report-footer">
            <div class="report-stats">
              <span class="field-count">{{ report.fields.length }} fields</span>
              <span class="filter-count">{{ report.filters?.length || 0 }} filters</span>
            </div>
            <div class="report-actions">
              <button class="action-btn delete-btn" (click)="deleteReport(report._id); $event.stopPropagation()" title="Delete report">
                <i class="pi pi-trash"></i>
              </button>
              <i class="pi pi-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Predefined Templates -->
    <!-- <div class="predefined-templates-section">
      <h2 class="section-title">
        <i class="pi pi-star"></i>
        Predefined Report Templates
      </h2>
      
      <div class="templates-grid">
        <div class="template-card" *ngFor="let template of reports" (click)="useTemplate(template)">
          <div class="template-header">
            <div class="template-icon">
              <i [class]="getDataSourceIcon(template.dataSource)"></i>
            </div>
            <div class="template-badge" [class]="template.isGlobal ? 'global' : 'subscriber'">
              {{ template.isGlobal ? 'Global' : 'Subscriber' }}
            </div>
          </div>
          
          <div class="template-content">
            <h3 class="template-title">{{ template.name }}</h3>
            <p class="template-description">{{ template.description }}</p>
            <div class="template-meta">
              <span class="template-category">{{ template.category }}</span>
              <span class="template-source">{{ template.dataSource }}</span>
            </div>
          </div>
          
          <div class="template-footer">
            <div class="template-stats">
              <span class="field-count">{{ template.fields.length }} fields</span>
              <span class="filter-count">{{ template.filters.length }} filters</span>
            </div>
            <div class="template-actions">
              <i class="pi pi-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>

  <!-- Report Builder Drawer -->
  <p-drawer header="Report Builder" [(visible)]="reportBuilderVisible" [modal]="true" [closable]="true" [style]="{ width: '90vw' }" position="right" >

    <div class="report-builder">
      <!-- Report Configuration -->
      <div class="builder-section">
        <h3 class="section-title">Report Configuration</h3>
        <form [formGroup]="reportForm" class="report-form min-h-[300px]">
          <div class="form-field">
            <label for="name">Report Name *</label>
            <input pInputText id="name" formControlName="name" placeholder="Enter report name" i18n-placeholder class="w-full">
          </div>

          <div class="form-field">
            <label for="dataSource">Data Source *</label>
            <div class="data-source-button-group">
              <button
                *ngFor="let source of getDataSources()"
                type="button"
                pButton
                [label]="source.label"
                [icon]="source.icon"
                [ngClass]="{
                  'p-button-primary': reportForm.get('dataSource')?.value === source.value,
                  'p-button-outlined': reportForm.get('dataSource')?.value !== source.value,
                  'data-source-btn': true
                }"
                (click)="selectDataSource(source.value)">
              </button>
            </div>
          </div>
          
          <div class="form-field">
            <label for="description">Description</label>
            <textarea pInputTextarea id="description" formControlName="description" placeholder="Enter report description" i18n-placeholder rows="3" class="w-full">
              </textarea>
          </div>

        </form>
      </div>

      <!-- Field Selection -->
      <div class="builder-section" *ngIf="selectedDataSource">
        <h3 class="section-title">Select Fields</h3>

        <!-- Main Fields Section -->
        <div class="field-group" *ngIf="getGroupedFields().main.length > 0">
          <h4 class="field-group-title">
            <i class="pi pi-database"></i>
            {{ selectedDataSource | titlecase }} Fields
          </h4>
          <div class="fields-grid">
            <div class="field-card" *ngFor="let field of getGroupedFields().main" [class.selected]="isFieldSelected(field)" (click)="toggleFieldSelection(field)">
              <div class="field-header">
                <i [class]="getFieldTypeIcon(field.type)"></i>
                <span class="field-name">{{ field.label }}</span>
              </div>
              <div class="field-meta">
                <span class="field-type">{{ field.type }}</span>
                <div class="field-capabilities">
                  <i class="pi pi-eye" *ngIf="field.isVisible" title="Visible"></i>
                  <i class="pi pi-filter" *ngIf="field.isFilterable" title="Filterable"></i>
                  <i class="pi pi-chart-bar" *ngIf="field.isChartable" title="Chartable"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Related Fields Sections -->
        <div class="field-group" *ngFor="let relatedModel of getObjectKeys(getGroupedFields().related)">
          <h4 class="field-group-title collapsible" (click)="toggleRelatedSection(relatedModel)">
            <i class="pi pi-link"></i>
            {{ relatedModel | titlecase }} Fields
            <span class="related-badge">Related</span>
            <i class="pi pi-chevron-down" [class.rotated]="isRelatedSectionOpen(relatedModel)"></i>
          </h4>
          <div class="fields-grid" [class.collapsed]="!isRelatedSectionOpen(relatedModel)">
            <div class="field-card related-field" *ngFor="let field of getGroupedFields().related[relatedModel]" [class.selected]="isFieldSelected(field)" (click)="toggleFieldSelection(field)">
              <div class="field-header">
                <i [class]="getFieldTypeIcon(field.type)"></i>
                <span class="field-name">{{ field.label }}</span>
              </div>
              <div class="field-meta">
                <span class="field-type">{{ field.type }}</span>
                <div class="field-capabilities">
                  <i class="pi pi-eye" *ngIf="field.isVisible" title="Visible"></i>
                  <i class="pi pi-filter" *ngIf="field.isFilterable" title="Filterable"></i>
                  <i class="pi pi-chart-bar" *ngIf="field.isChartable" title="Chartable"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="selected-fields" *ngIf="selectedFields.length > 0">
          <h4>Selected Fields ({{ selectedFields.length }})</h4>
          <div class="selected-fields-list">
            <div class="selected-field-tag" *ngFor="let field of selectedFields">
              <span class="field-label">{{ field.label }}</span>
              <button class="remove-btn" (click)="removeSelectedField(field)" title="Remove field">
                <i class="pi pi-times"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Filters -->
      <div class="builder-section " *ngIf="selectedFields.length > 0">
        <h3 class="section-title">Add Filters</h3>

        <form [formGroup]="filterForm" class="filter-form">
          <div class="filter-row">
            <div class="filter-field ">
              <label>Field</label>
              <p-select formControlName="field" [options]="getSelectedFieldsOptions()" placeholder="Select field" i18n-placeholder class="w-full">
              </p-select>
            </div>
            <div class="filter-field">
              <label>Operator</label>
              <p-select formControlName="operator" [options]="getFilterOperators()" placeholder="Select operator" i18n-placeholder class="w-full">
              </p-select>
            </div>
            <div class="filter-field">
              <label>Value</label>
              <!-- Show select dropdown for fields with predefined options -->
              <p-select *ngIf="hasPredefinedOptions()" formControlName="value" [options]="getFilterOptions(getSelectedFieldForFilter()!)" placeholder="Select value" i18n-placeholder class="w-full">
              </p-select>
              <!-- Show input for fields without predefined options -->
              <input *ngIf="!hasPredefinedOptions()" pInputText formControlName="value" placeholder="Enter value" i18n-placeholder class="w-full">
            </div>
            <div class="filter-field">
              <p-button label="Add Filter" icon="pi pi-plus" (onClick)="addFilter()" [disabled]="!filterForm.get('field')?.value" styleClass="p-button-outlined">
              </p-button>
            </div>
          </div>
        </form>

        <!-- Date Range Filter Section -->
        <div class="date-range-filter-section overflow-visible" *ngIf="hasDateFields()">
          <h4>Date Range Filter</h4>
          <div class="date-range-filter-content">
            <div class="date-range-toggle">
              <p-checkbox [(ngModel)]="dateRangeFilter.enabled" (ngModelChange)="dateRangeFilter.enabled ? enableDateRangeFilter() : disableDateRangeFilter()" inputId="enableDateRange" [binary]="true">
              </p-checkbox>
              <label for="enableDateRange" class="ml-2">Enable Date Range Filter</label>
            </div>

            <div class="date-range-settings" *ngIf="dateRangeFilter.enabled">
              <div class="date-range-row pb-48">
                <div class="date-range-field">
                  <label>Date Field</label>
                  <p-select [(ngModel)]="dateRangeFilter.field" [options]="getDateFields()" optionLabel="label" optionValue="name" placeholder="Select date field" i18n-placeholder class="w-full">
                  </p-select>
                </div>
                <div class="date-range-field">
                  <label>Start Date</label>
                  <p-datePicker [(ngModel)]="dateRangeFilter.startDate" placeholder="Select start date" i18n-placeholder [showIcon]="true" dateFormat="dd/mm/yy" class="w-full">
                  </p-datePicker>
                </div>
                <div class="date-range-field">
                  <label>End Date</label>
                  <p-datePicker [(ngModel)]="dateRangeFilter.endDate" placeholder="Select end date" i18n-placeholder [showIcon]="true" dateFormat="dd/mm/yy" class="w-full">
                  </p-datePicker>
                </div>
              </div>

              <div class="date-range-info" *ngIf="dateRangeFilter.field">
                <small class="text-600">
                  <i class="pi pi-info-circle"></i>
                  Filtering by {{ getDateRangeFilterField()?.label }} from
                  {{ dateRangeFilter.startDate | date:'short' }} to
                  {{ dateRangeFilter.endDate | date:'short' }}
                </small>
              </div>
            </div>
          </div>
        </div>

        <div class="active-filters" *ngIf="selectedFilters.length > 0">
          <h4>Active Filters ({{ selectedFilters.length }})</h4>
          <div class="filters-list">
            <div class="filter-item" *ngFor="let filter of selectedFilters; let i = index">
              <span class="filter-label">{{ filter.label }}</span>
              <span class="filter-operator">{{ filter.operator }}</span>
              <span class="filter-value">{{ filter.value }}</span>
              <p-button appGlobalLoadingDisable icon="pi pi-times" [text]="true" [rounded]="true" severity="danger" (onClick)="removeFilter(i)" size="small">
              </p-button>
            </div>
          </div>
        </div>
      </div>

      <!-- Chart Configuration -->
      <div class="builder-section" *ngIf="canCreateChart()">
        <h3 class="section-title">Chart Configuration</h3>
        <div class="chart-info mb-3">
          <small class="text-600">
            <i class="pi pi-info-circle"></i>
            Charts require one categorical field (X-axis).
            <span *ngIf="getChartableFields().length > 0">
              You can also add chartable fields (Y-axis) for more detailed charts.
            </span>
            <span *ngIf="getChartableFields().length === 0">
              Without chartable fields, charts will show record counts.
            </span>
            Available: {{ getCategoricalFields().length }} categorical fields, {{ getChartableFields().length }} chartable fields.
          </small>
        </div>

        <div class="chart-config">
          <div class="chart-toggle">
            <p-toggleswitch [ngModel]="chartConfig?.enabled" (ngModelChange)="updateChartEnabled($event); initializeChart()" inputId="enableChart">
            </p-toggleswitch>
            <label for="enableChart" class="ml-2">Enable Chart</label>
          </div>

          <div class="chart-settings" *ngIf="chartConfig?.enabled">
            <!-- Chart Validation Error/Warning -->
            <div class="chart-validation-message mb-3" *ngIf="getChartValidationStatus().isValid === false">
              <div class="p-3 border-round-md" [ngClass]="{'bg-red-50 border-2 border-red-200': getChartValidationStatus().error, 'bg-yellow-50 border-2 border-yellow-200': getChartValidationStatus().warning}">
                <div class="flex align-items-center gap-2">
                  <i class="pi" [ngClass]="{'pi-exclamation-triangle text-red-600': getChartValidationStatus().error, 'pi-info-circle text-yellow-600': getChartValidationStatus().warning}"></i>
                  <div class="flex-1">
                    <strong class="block mb-1" [ngClass]="{'text-red-700': getChartValidationStatus().error, 'text-yellow-700': getChartValidationStatus().warning}">
                      {{ getChartValidationStatus().error ? 'Chart Configuration Error' : 'Chart Configuration Warning' }}
                    </strong>
                    <p class="text-sm m-0" [ngClass]="{'text-red-600': getChartValidationStatus().error, 'text-yellow-600': getChartValidationStatus().warning}">
                      {{ getChartValidationStatus().error || getChartValidationStatus().warning }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="chart-row">
              <div class="chart-field">
                <label>Chart Type</label>
                <p-select [ngModel]="chartConfig?.type" (ngModelChange)="updateChartType($event)" [options]="getChartTypes()" placeholder="Select chart type" i18n-placeholder class="w-full">
                </p-select>
              </div>
              <div class="chart-field">
                <label>X-Axis (Categorical Field) *</label>
                <p-select [ngModel]="chartConfig?.xAxis" (ngModelChange)="updateChartXAxis($event)" [options]="getCategoricalFieldsOptions()" placeholder="Select categorical field (string, date, boolean)" i18n-placeholder class="w-full" [ngClass]="{'p-invalid': getChartValidationStatus().isValid === false && !chartConfig?.xAxis}">
                </p-select>
                <small class="text-600 block mt-1">
                  <i class="pi pi-info-circle"></i>
                  Required: Select a categorical field to group your data (e.g., status, category, date)
                </small>
              </div>
            </div>

            <div class="chart-field" *ngIf="getChartableFields().length > 0">
              <label>Y-Axis Fields (Chartable Fields)</label>
              <p-multiSelect [ngModel]="chartConfig?.yAxis" (ngModelChange)="updateChartYAxis($event)" [options]="getChartableFieldsOptions()" placeholder="Select chartable fields (optional)" i18n-placeholder class="w-full">
              </p-multiSelect>
              <small class="text-600 block mt-1">
                <i class="pi pi-info-circle"></i>
                Optional: Select numeric or countable fields to display values (e.g., amount, quantity, count)
              </small>
            </div>

            <div class="chart-field" *ngIf="getChartableFields().length === 0">
              <div class="chart-info">
                <small class="text-600">
                  <i class="pi pi-info-circle"></i>
                  No chartable fields selected. Chart will show record counts by the selected categorical field.
                </small>
              </div>
            </div>

            <div class="chart-field">
              <label>Chart Title</label>
              <input pInputText [ngModel]="chartConfig?.title" (ngModelChange)="updateChartTitle($event)" placeholder="Enter chart title" i18n-placeholder class="w-full">
            </div>
          </div>
        </div>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <div class="dialog-footer">
        <div class="footer-left">
          <div class="save-options">
            <p-checkbox [(ngModel)]="isPublic" [binary]="true" inputId="isPublicMakePublic">
            </p-checkbox>
            <label for="isPublicMakePublic" class="ml-2">Make Public</label>
            <p-button label="Save Report" icon="pi pi-save" (onClick)="saveReportFromForm()" [disabled]="!isReportValid()" styleClass="p-button-success">
            </p-button>
          </div>
        </div>

        <div class="footer-right">
          <p-button appGlobalLoadingDisable label="Cancel" icon="pi pi-times" (onClick)="closeDialogs()" styleClass="p-button-text">
          </p-button>
          <p-button label="Execute Report" icon="pi pi-play" (onClick)="executeReport()" [loading]="loading" [disabled]="!isReportValid()" styleClass="p-button-primary">
          </p-button>
        </div>
      </div>
    </ng-template>
  </p-drawer>

  <!-- Report Execution Dialog -->
  <p-dialog header="Report Results" [(visible)]="reportExecutionVisible" [modal]="true" [closable]="true" [style]="{ width: '95vw', height: '90vh' }" [maximizable]="true">

    <div class="report-results" *ngIf="reportData">
      <!-- Report Header -->
      <div class="results-header">
        <div class="results-info">
          <h3>{{ currentReport?.name }}</h3>
          <p>{{ currentReport?.description }}</p>
          <div class="results-meta">
            <span class="execution-time">
              <i class="pi pi-clock"></i>
              Executed in {{ reportData.executionTime }}ms
            </span>
            <span class="total-records">
              <i class="pi pi-database"></i>
              {{ reportData.total }} records
            </span>
          </div>
        </div>

        <div class="results-actions">
          <p-button label="View Chart" icon="pi pi-chart-bar" (onClick)="toggleChartView()" *ngIf="chartConfig?.enabled" styleClass="p-button-outlined" [severity]="chartError ? 'warn' : 'secondary'">
          </p-button>
        </div>
      </div>

      <!-- Chart View -->
      <div class="chart-section" *ngIf="chartViewVisible">
        <h4>Chart Visualization</h4>
        
        <!-- Chart Error Message -->
        <div class="chart-error-message mb-3" *ngIf="chartError">
          <div class="p-3 border-round-md bg-red-50 border-2 border-red-200">
            <div class="flex align-items-center gap-2">
              <i class="pi pi-exclamation-triangle text-red-600"></i>
              <div class="flex-1">
                <strong class="block mb-1 text-red-700">Chart Generation Failed</strong>
                <p class="text-sm m-0 text-red-600">{{ chartError }}</p>
                <div class="mt-2 text-sm text-red-600">
                  <strong>How to fix:</strong>
                  <ul class="mt-1 ml-3" style="list-style-type: disc;">
                    <li *ngIf="chartError.includes('X-axis')">Select a categorical field (string, date, or boolean) for the X-axis in the chart configuration</li>
                    <li *ngIf="chartError.includes('No data')">Check your filters - they may be too restrictive. Try removing or adjusting filters.</li>
                    <li *ngIf="chartError.includes('field') && chartError.includes('not exist')">Ensure the selected field is included in your report fields</li>
                    <li *ngIf="chartError.includes('Y-axis')">Select valid chartable fields (numeric or countable) for the Y-axis, or leave empty to show record counts</li>
                    <li *ngIf="!chartError.includes('X-axis') && !chartError.includes('No data') && !chartError.includes('Y-axis')">Review your chart configuration and ensure all selected fields are valid and available in the data</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Chart Display -->
        <div class="chart-container" *ngIf="chartData && !chartError">
          <p-chart [type]="chartConfig?.type || 'bar'" [data]="chartData" [options]="chartOptions" height="400px">
          </p-chart>
        </div>

        <!-- No Chart Data Message -->
        <div class="chart-no-data p-4 text-center" *ngIf="!chartData && !chartError">
          <i class="pi pi-chart-bar text-4xl text-400 mb-2"></i>
          <p class="text-500">Chart data is not available. Please check your chart configuration.</p>
        </div>
      </div>

      <!-- Data Table -->
      <div class="data-section">
        <h4>Data Table</h4>

        <!-- Table Info -->
        <div class="flex justify-between align-items-center mb-3">
          <div class="flex gap-4">
            <span class="text-sm">
              <strong>Total Records:</strong> {{ reportData.total || 0 | number:'1.0-0':'de-DE' }}
            </span>
            <span class="text-sm">
              <strong>Execution Time:</strong> {{ formatExecutionTime(reportData.executionTime) }}
            </span>
          </div>
          <div class="flex gap-2">
            <div class="export-button-group">
              <span class="export-label">Export</span>
              <p-button 
                type="button"
                icon="pi pi-chevron-down"
                [disabled]="!reportData.data.length"
                styleClass="p-button-icon-only export-dropdown-btn"
                (onClick)="exportMenuSimple.toggle($event)"
                aria-label="Export options">
              </p-button>
              <p-menu #exportMenuSimple [model]="exportMenuItems" [popup]="true"></p-menu>
            </div>
          </div>
        </div>

        <p-table [value]="reportData.data || []" [paginator]="false" [rows]="pageSize" [loading]="loading" [scrollable]="true" scrollHeight="400px" [tableStyle]="{'min-width': '800px', 'width': '100%'}" styleClass="p-datatable-sm">

          <ng-template pTemplate="header">
            <tr>
              <th *ngFor="let field of selectedFields" [pSortableColumn]="field.name">
                {{ field.label }}
                <p-sortIcon [field]="field.name"></p-sortIcon>
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-rowData>
            <tr>
              <td *ngFor="let field of selectedFields">
                {{ formatValue(rowData[field.name], field) }}
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td [attr.colspan]="selectedFields?.length || 1" class="text-center py-4">
                <div class="flex flex-column align-items-center gap-2">
                  <i class="pi pi-inbox text-4xl text-400"></i>
                  <span class="text-500">No data available</span>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>

        <!-- Pagination -->
        <nav class="flex justify-between align-items-center pb-48 mt-4" *ngIf="reportData && reportData.total > pageSize">
          <div class="text-sm text-600">
            Showing {{ (currentPage - 1) * pageSize + 1 }} to {{ Math.min(currentPage * pageSize, reportData.total || 0) }} of {{ reportData.total || 0 }} entries
          </div>

          <p-paginator [rows]="pageSize" [totalRecords]="reportData.total || 0" [rowsPerPageOptions]="[10, 25, 50, 100]" (onPageChange)="onPageChange($event)" [showCurrentPageReport]="false" [attr.aria-label]="'Navigate through report pages'">
          </p-paginator>
        </nav>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <div class="dialog-footer">
        <p-button appGlobalLoadingDisable label="Close" icon="pi pi-times" (onClick)="closeDialogs()" styleClass="p-button-text">
        </p-button>
      </div>
    </ng-template>
  </p-dialog>

  <!-- Loading Overlay -->
  <div class="loading-overlay" *ngIf="loading">
    <p-progressSpinner [style]="{ width: '50px', height: '50px' }" strokeWidth="4" fill="transparent" animationDuration="1s">
    </p-progressSpinner>
  </div>

  <!-- Save Report Dialog -->
  <p-dialog header="Save Report" [(visible)]="showSaveDialog" [modal]="true" [style]="{ width: '500px' }" [closable]="true">

    <div class="save-dialog-content">
      <div class="form-group">
        <label for="reportName">Report Name *</label>
        <input id="reportName" type="text" pInputText [(ngModel)]="reportName" placeholder="Enter report name" i18n-placeholder class="w-full">
      </div>

      <div class="form-group">
        <label for="reportDescription">Description</label>
        <textarea id="reportDescription" pInputTextarea [(ngModel)]="reportDescription" placeholder="Enter report description (optional)" i18n-placeholder rows="3" class="w-full">
        </textarea>
      </div>

      <div class="form-group">
        <p-checkbox [(ngModel)]="isPublic" [binary]="true" inputId="isPublic">
        </p-checkbox>
        <label for="isPublic" class="ml-2">Make this report publicly available</label>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <div class="dialog-footer">
        <p-button appGlobalLoadingDisable label="Cancel" icon="pi pi-times" (onClick)="cancelSave()" styleClass="p-button-text">
        </p-button>
        <p-button appGlobalLoadingDisable label="Save" icon="pi pi-save" (onClick)="saveReport()" [loading]="loading" styleClass="p-button-primary">
        </p-button>
      </div>
    </ng-template>
  </p-dialog>

  <!-- Load Report Dialog -->
  <p-dialog header="Load Saved Report" [(visible)]="showLoadDialog" [modal]="true" [style]="{ width: '800px' }" [closable]="true">

    <div class="load-dialog-content">
      <div class="saved-reports-list" *ngIf="savedReports.length > 0">
        <div class="report-item" *ngFor="let report of savedReports">
          <div class="report-info">
            <h4 class="report-name">{{ report.name }}</h4>
            <p class="report-description" *ngIf="report.description">{{ report.description }}</p>
            <div class="report-meta">
              <span class="data-source">{{ report.dataSource }}</span>
              <span class="fields-count">{{ report.fields.length }} fields</span>
              <span class="created-by" *ngIf="report.createdBy">
                by {{ report.createdBy.firstName }} {{ report.createdBy.lastName }}
              </span>
              <span class="public-badge" *ngIf="report.isPublic">Public</span>
            </div>
          </div>
          <div class="report-actions">
            <p-button appGlobalLoadingDisable label="Load" icon="pi pi-folder-open" (onClick)="loadReport(report)" styleClass="p-button-primary p-button-sm">
            </p-button>
            <p-button appGlobalLoadingDisable label="Delete" icon="pi pi-trash" (onClick)="deleteReport(report._id)" styleClass="p-button-danger p-button-sm">
            </p-button>
          </div>
        </div>
      </div>

      <div class="no-reports" *ngIf="savedReports.length === 0">
        <div class="empty-state">
          <i class="pi pi-folder-open text-4xl text-400"></i>
          <h3>No Saved Reports</h3>
          <p>You haven't saved any reports yet. Create and save your first report to get started.</p>
        </div>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <div class="dialog-footer">
        <p-button appGlobalLoadingDisable label="Close" icon="pi pi-times" (onClick)="cancelLoad()" styleClass="p-button-text">
        </p-button>
      </div>
    </ng-template>
  </p-dialog>
</div>